export const LOGO_URL =
    "https://customer-assets-v7afamib.emergentagent.net/job_zapp-book-exchange/artifacts/kv6lvp4t_Gemini_Generated_Image_4unpql4unpql4unp.png";
